module.exports = require("react-hotkeys-hook");